import React from 'react';
import Paper from '@material-ui/core/Paper';
import BCLStyledListItem from '../../../common/InsightItem/BCLStyledListItem';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { InsightConstants } from './InsightConstants';
import BCLButton from '../../../common/Buttons/BCLButton';
import { Configuration } from '../../../../configs/Configuration';
import { trackEvent } from '../../../../helpers/analyticsHelper';
import { PAGE_EVENT_NAMES, DASHBOARD, FUEL_TYPE } from '../../../../constants/common';


export default function Insights(props){

    const [open, setOpen] = React.useState(false);
    const configColors = Configuration.getColors().colors;

    function handleClickOpen() {
      trackEvent(props.userId , PAGE_EVENT_NAMES.DASHBOARD , {
        clicked: DASHBOARD.READ_MORE_INSIGHT,
        dashboardView: FUEL_TYPE.ELECTRIC
      })
      setOpen(true);
    };

    function handleClose() {
      setOpen(false);
    }

    return(
      <Paper className="insights-container">
        <div className="insights-header">
          {props.translations["HOME.INSIGHTS.TITLE"]}
        </div>
        <div className="insights-content">
          {
            props.insights.slice(0,3).map((insight, index) => (
              <div key={index} className="insights">
                <BCLStyledListItem type={InsightConstants[insight.feedType].name}
                                description={insight.description}
                                title={insight.title}
                                itemComputedTime = {insight.computedDateTimeString}
                                bannerBg={`rgb(${configColors[InsightConstants[insight.feedType].bannerColor]})`}
                                configColors={configColors}/>
              </div>
            ))
          }
        </div>
        {props.insights.length > 3 &&
          <div className="insights-button">
            <BCLButton className="dialog-open-btn" variant="outlined" textColor={`rgb(${configColors['--color_1']})`} borderColor={`rgb(${configColors['--color_1']})`} hoverColor={`rgb(${configColors['--color_1']})`} hoverTextColor={`rgb(${configColors['--color_7']})`} onClick={handleClickOpen} btnText={props.translations["HOME.INSIGHTS.READ_MORE"]} btnWidth="calc(100% - 50px)"></BCLButton>
          </div>
        }
        <Dialog open={open} onClose={handleClose} aria-labelledby="scroll-dialog-title">
          <DialogTitle id="scroll-dialog-title">{props.translations["HOME.INSIGHTS.YOUR_INSIGHTS"]}</DialogTitle>
          <DialogContent dividers={true}>
            <div className="insights-content popup-insights-content">
              {
                props.insights.map((insight, index) => (
                  <div key={index} className="insights">
                    <BCLStyledListItem type={InsightConstants[insight.feedType].name}
                                description={insight.description}
                                title={insight.title}
                                itemComputedTime = {insight.computedDateTimeString}
                                bannerBg={`rgb(${configColors[InsightConstants[insight.feedType].bannerColor]})`}
                                configColors={configColors}/>
                  </div>
                ))
              }
            </div>
            <BCLButton className="dialog-close-btn" variant="outlined" textColor={`rgb(${configColors['--color_1']})`} borderColor={`rgb(${configColors['--color_1']})`} hoverColor={`rgb(${configColors['--color_1']})`} hoverTextColor={`rgb(${configColors['--color_7']})`} onClick={handleClose} btnText={props.translations["HOME.INSIGHTS.CLOSE"]} btnWidth="100%"></BCLButton>
          </DialogContent>
        </Dialog>
        {props.insightListError && (
          <div className="home-api-error">{props.translations["HOME.INSIGHTS.API_ERROR"]}</div>
        )}
      </Paper>
    );
}
